import { useState } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";
import PageWrapper from "../components/PageWrapper";
import api from "../utils/apiAxios";

export default function PenjualanHarian() {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [search, setSearch] = useState("");

  // ===== TABLE STYLE =====
  const customStyles = {
    headCells: {
      style: {
        backgroundColor: "#f3f4f6",
        fontSize: "12px",
        fontWeight: "600",
        color: "#111827",
      },
    },
    rows: {
      style: {
        fontSize: "12px",
      },
    },
  };

  const fmt = (val) =>
    new Intl.NumberFormat("id-ID").format(val || 0);

  // ===== GROUPING =====
  const groupBy = (arr, key) => {
    return arr.reduce((acc, item) => {
      const group = item[key] || "Unknown";

      if (!acc[group]) {
        acc[group] = {
          label: group,
          qty: 0,
          netto: 0,
        };
      }

      acc[group].qty += Number(item.qty || 0);
      acc[group].netto += Number(item.netto || 0);

      return acc;
    }, {});
  };

  const kasirSummary = Object.values(groupBy(data, "kasir"));
  const pembayaranSummary = Object.values(groupBy(data, "type_pembayaran"));
  const brandSummary = Object.values(groupBy(data, "prinsipal"));
  const deptSummary = Object.values(groupBy(data, "dept"));

  // ===== SUMMARY =====
  const summary = data.reduce(
    (acc, item) => {
      const netto = Number(item.netto || 0);

      acc.qty += Number(item.qty || 0);
      acc.hjp += Number(item.hjp || 0);
      acc.netto += netto;
      acc.discount_rp += Number(item.discount_rp || 0);

      if (item.type_pembayaran === "TIKTOK") {
        acc.tiktok_netto += netto;
      }

      return acc;
    },
    { qty: 0, hjp: 0, netto: 0, discount_rp: 0, tiktok_netto: 0 }
  );

  const nettoValidasi = summary.netto - summary.tiktok_netto;

  // ===== FILTER =====
  const filteredData = data.filter((item) => {
    const keyword = search.toLowerCase();

    return (
      item.tanggal_penjualan?.toLowerCase().includes(keyword) ||
      item.id_penjualan?.toLowerCase().includes(keyword) ||
      item.kode_extend?.toLowerCase().includes(keyword) ||
      item.dept?.toLowerCase().includes(keyword)
    );
  });

  // ===== API =====
  const handleSearch = async () => {
    if (!startDate || !endDate) return alert("Tanggal harus diisi");

    try {
      setLoading(true);

      const kode_toko = localStorage.getItem("kode_toko");
       const id_sunfish = localStorage.getItem("id_sunfish");
 const token = localStorage.getItem("token");
      const res = await api.get("/api/sales/daily", {
        params: {
          start_date: startDate,
          end_date: endDate,
          kode_toko,
          id_sunfish
        },
      });

      setData(res.data.data);
    } catch (err) {
      alert("Gagal ambil data");
    } finally {
      setLoading(false);
    }
  };

 const handleExport = async () => {
  if (!startDate || !endDate) {
    return alert("Tanggal harus diisi");
  }

  try {
    const kode_toko = localStorage.getItem("kode_toko");

    const res = await api.get("/api/sales/daily/export", {
      params: {
        start_date: startDate,
        end_date: endDate,
        kode_toko,
      },
      responseType: "blob",
    });

    // create download link
    const url = window.URL.createObjectURL(new Blob([res.data]));

    const link = document.createElement("a");

    link.href = url;
    link.setAttribute("download", "penjualan-harian.xlsx");

    document.body.appendChild(link);

    link.click();

    link.remove();
  } catch (err) {
    console.error(err);
  }
};

  // ===== COLUMNS =====
  const columns = [
    {
  name: "Foto",
  width: "90px",
  cell: row => {
    const imgUrl = `https://asset-3s.3second.co.id/product/${row.kode_extend}_1.JPG`;

    return (
      <div className="py-2">
        <div className="w-12 h-12 rounded-lg overflow-hidden border bg-gray-50 flex items-center justify-center">
          <img
            src={imgUrl}
            alt={row.kode_extend}
            className="w-full h-full object-cover"
            loading="lazy"
            onError={(e) => {
              e.target.onerror = null;
              e.target.src =
                "https://via.placeholder.com/60x60?text=No+Image";
            }}
          />
        </div>
      </div>
    );
  }
},
  { name: "Tanggal", selector: row => row.tanggal_penjualan, sortable: false },
 {
  name: "ID Penjualan",
  selector: row => row.id_penjualan,
  sortable: false,
  minWidth: "180px",
  cell: row => (
    <span className="truncate max-w-[160px] block">
      {row.id_penjualan}
    </span>
  )
},
  { name: "Kasir", selector: row => row.kasir, sortable: true },
 {
  name: "Status",
  sortable: true,
  cell: row => {
    const isClosing = row.status?.toLowerCase() === "closing";

    return (
      <span
        className={`px-2 py-1 text-[11px] rounded-full font-medium
          ${
            isClosing
              ? "bg-green-100 text-green-700"
              : "bg-gray-100 text-gray-600"
          }
        `}
      >
        {row.status}
      </span>
    );
  },
},
   { name: "Type Pembayaran", selector: row => row.type_pembayaran, sortable: true },
   { name: "Program Promosi", selector: row => row.nik, sortable: true },
    { name: "Artikel", selector: row => row.kode_extend, sortable: true },
  { name: "Ukuran", selector: row => row.ukuran, sortable: true },
  { name: "Dept", selector: row => row.dept },
  { name: "Brand", selector: row => row.prinsipal },

  {
    name: "HJP",
    right: true,
    selector: row => Number(row.hjp).toLocaleString(),
  },
  {
    name: "Netto",
    right: true,
    selector: row => Number(row.netto).toLocaleString(),
  },
  {
    name: "Qty",
    right: true,
    selector: row => row.qty,
  },
  {
    name: "Discount",
    right: true,
    selector: row => row.discount,
  },
  {
    name: "Discount Rp",
    right: true,
    selector: row => Number(row.discount_rp).toLocaleString(),
  },
  
];

  // ===== SUMMARY CARD =====
  const SummaryCard = ({ label, value }) => (
    <div className="bg-white border rounded-2xl p-4 shadow-sm hover:shadow-md transition">
      <p className="text-xs text-gray-500">{label}</p>
      <p className="text-xl font-semibold text-gray-900">
        {fmt(value)}
      </p>
    </div>
  );

  return (
    <PageWrapper>
      <div className="space-y-6">

        {/* INFO */}
        <div className="rounded-2xl border bg-blue-50 p-5 text-sm">
          <p className="font-semibold text-gray-900">
            Informasi Data Penjualan
          </p>
          <p className="text-gray-600 mt-1">
            Maksimal 7 hari per request. Gunakan export untuk data besar.
          </p>
        </div>

        {/* FILTER */}
        <div className="bg-white border rounded-2xl p-4 shadow-sm flex flex-wrap gap-3 items-center">

          <input
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            className="border rounded-xl px-3 py-2 text-sm"
          />

          <input
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            className="border rounded-xl px-3 py-2 text-sm"
          />

          <div className="ml-auto flex gap-2">
            <button
              onClick={handleSearch}
              className="bg-black text-white px-4 py-2 rounded-xl text-sm"
            >
              {loading ? "Loading..." : "Tampilkan"}
            </button>

            <button
              onClick={handleExport}
              className="border px-4 py-2 rounded-xl text-sm"
            >
              Export
            </button>
          </div>

        </div>

        {/* SUMMARY */}
        <div className="grid grid-cols-1 md:grid-cols-5 gap-4">

          <SummaryCard label="Total Qty" value={summary.qty} />
          <SummaryCard label="Total HJP" value={summary.hjp} />
          <SummaryCard label="Total Netto" value={summary.netto} />
          <SummaryCard label="Discount" value={summary.discount_rp} />

          <div className="bg-blue-50 border rounded-2xl p-4">
            <p className="text-xs text-gray-500">Netto Validasi</p>
            <p className="text-xl font-bold text-blue-600">
              {fmt(nettoValidasi)}
            </p>
          </div>

        </div>

        {/* TABLE */}
        <div className="bg-white border rounded-2xl p-4 shadow-sm">

          <div className="flex gap-2 mb-3">
            <input
              className="border rounded-xl px-3 py-2 text-sm w-64"
              placeholder="Cari..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />

            <button
              onClick={() => setSearch("")}
              className="text-xs border px-3 rounded-xl"
            >
              Reset
            </button>
          </div>

          <DataTable
            columns={columns}
            data={filteredData}
            progressPending={loading}
            pagination
            customStyles={customStyles}
            highlightOnHover
            dense
          />
        </div>

       {/* BREAKDOWN */}
<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">

  {[
    { title: "Per Kasir", data: kasirSummary, color: "text-blue-600" },
    { title: "Per Pembayaran", data: pembayaranSummary, color: "text-green-600" },
    { title: "Per Brand", data: brandSummary, color: "text-purple-600" },
    { title: "Per Dept", data: deptSummary, color: "text-orange-600" },
  ].map((group, i) => (

    <div
      key={i}
      className="bg-white border rounded-2xl p-4 shadow-sm hover:shadow-md transition"
    >

      {/* HEADER */}
      <div className="flex items-center justify-between mb-3">
        <p className={`font-semibold text-sm ${group.color}`}>
          {group.title}
        </p>

        <span className="text-[10px] text-gray-400">
          {group.data.length} item
        </span>
      </div>

      {/* LIST */}
      <div className="space-y-2 max-h-60 overflow-auto pr-1">

        {group.data
          .slice()
          .sort((a, b) => b.netto - a.netto)
          .map((x, idx) => (
            <div
              key={idx}
              className="flex items-center justify-between text-xs border-b pb-1"
            >

              {/* LABEL */}
              <span className="text-gray-600 truncate max-w-[140px]">
                {x.label}
              </span>

              {/* VALUE */}
              <div className="text-right">
                <p className="font-medium text-gray-900">
                  {fmt(x.netto)}
                </p>
                <p className="text-[10px] text-gray-400">
                  Qty: {fmt(x.qty)}
                </p>
              </div>

            </div>
          ))}

      </div>

    </div>
  ))}

</div>

      </div>
    </PageWrapper>
  );
}